import React, { useState } from 'react'
import { Button, Dropdown, Menu, message, Switch, Timeline as AntdTimeLine, Divider, Spin } from 'antd';
import { useFetch, useDiscord} from '@utils';
import CommentForm from '../timline/comments/comment-form';
import TimelineItem from '../timline/TimeLineItem';
import CommentReadSnackbar from '../timline/comments/comment-read-snackbar';
import { MoreOutlined } from '@ant-design/icons';
import { useContext } from 'react';
import { appContext } from '../../AppContext';

export default function CharacterComments({characterId, characterName}) {

    const [submitting, setSubmitting] = useState(true);
    const [isLoading, setIsLoading] = useState(true);
    const [content, setContent] = useState()
    const [doFetch, FetchOptions] = useFetch();
    const [sendDiscordUpdate] = useDiscord();
    const [dataSource, setDataSource] = useState([]);
    const [showHiddenComments, setShowHiddenComments] = useState(false);
    const [showUnreadCommentsOnly, setShowUnreadCommentsOnly] = useState(false);
    const [orderCommentsDesc, setOrderCommentsDesc] = useState(true);
    const [appState] = useContext(appContext);
    const userId = appState.user.id;
    //const [comments, setComments] = useState([]);

    React.useEffect(() => {
        refresh();
    }, // eslint-disable-next-line
    [showHiddenComments])

    function refresh() {
        doFetch(`/api/comment/getbycharacterid/${characterId}/${showHiddenComments}`)
            .then((response) => characterLoaded(response.isSuccess, response.result))

        function characterLoaded(isSuccess, result) {
          if(isSuccess) {
            setDataSource(
              result.map((comment) => ({
                ...comment,
                type: "comment",
                isRead: checkIsRead(comment),
                children: comment.children.map((child) => ({
                  ...child,
                  type: "comment",
                  isRead: checkIsRead(child)
                }))
            })));
            
            setSubmitting(false);
            setIsLoading(false);
            return;
          }
          setSubmitting(false);
          setIsLoading(false);
          message.error('Comments failed to load')
          setDataSource([])
        }

        function checkIsRead(comment){
          return (userId === comment.larperId ||
          comment.personsWatched.filter((r) => r.larperId === userId).length > 0)
        }
    }

    function addComment(parentId, content, onlySl) {
        setSubmitting(true);
        const newComment = {
          parentId: parentId,
          content,
          onlySl: onlySl
        };
    
        return doFetch(`/api/comment/addcharactercomment/${characterId}`, FetchOptions.POST, newComment).then(
          (response) => {
            if (response.isSuccess) {
              refresh();
              sendDiscordUpdate(`${appState.user?.name} added a comment to a character with the name ${characterName}. https://app.larptom.nl/${appState.appName}/character?id=${characterId}`)
              return true;
            }

            message.error('Adding comment failed')
            setSubmitting(false);
            return false;
          }
        );
      }

      function eventReply(value) {
        setContent(value);
      }

    function saveComment(id, content) {
        const updatedComment = {
            id,
            content: content,
          };
          return doFetch(`/api/Comment/${id}`, FetchOptions.PUT, updatedComment).then(
            (response) => {
              if (response.isSuccess) {
                refresh();
                sendDiscordUpdate(`${appState.user?.name} updated a comment to a character with the name ${characterName}. https://app.larptom.nl/${appState.appName}/character?id=${characterId}`)
                return;
              }
              message.error('Updating comment failed')
              return;
            }
          );
    }

    function deleteComment(id) {
        doFetch(`/api/Comment/${id}`, FetchOptions.DELETE, null, true).then(
          (response) => {
            if (response.isSuccess) {
              refresh();
              return;
            }
            message.error('Deleting comment failed')
          }
        );
      }

      function hideComment(id) {
        doFetch(`/api/Comment/${id}/hide`, FetchOptions.POST, null, true).then(
          (response) => {
            if (response.isSuccess) {
              refresh();
              return;
            }
            message.error('Hiding comment failed')
          }
        );
      }

      function commentRead(id, value) {

        const body = {
          isRead: value
        };
    
          doFetch(`/api/Comment/${id}/seenBy`, FetchOptions.POST, body).then(
            (response) => commentReadLoaded(response.isSuccess, response.result)
          );
          function commentReadLoaded(isSuccess, result) {
            if (isSuccess) {
              const [foundComment] = findComment(id, dataSource);
              if (foundComment === undefined) {
                return;
              }
    
              foundComment.isRead = value;
              setDataSource([...dataSource]);
              return;
            }
        }
      }

      function addUnreadComment(id) {

        const [foundComment] = findComment(id, dataSource);
        if (foundComment === undefined) {
          return;
        }
        foundComment.isRead = false;
        setDataSource([...dataSource]);
      }

      function findComment(id, findInComments) {
        if (id === undefined || findInComments === undefined) return [undefined, findInComments];
        for (let comment of findInComments) {
          if (comment.id === id) return [comment, findInComments];
          const [foundComment, foundInComments] = findComment(id, comment.children);
          if (foundComment) return [foundComment, foundInComments];
        }
        return [undefined, findInComments];
      }
      
      const actionsDropdownComments = (
        <Menu onClick={handleActions}>
           <Menu.Item key="orderBy">
            {`Newest comments first `}
            <Switch 
              checked={orderCommentsDesc}
            />
          </Menu.Item>
          <Menu.Item key="changeUnreadOnly">
            {`Show only unread comments `}
            <Switch 
              checked={showUnreadCommentsOnly}
            />
          </Menu.Item>
          <Menu.Item key="changeShowHidden">
            {`Show archived comments `}
            <Switch 
              checked={showHiddenComments}
            />
          </Menu.Item>
        </Menu>
      );

      function handleActions({ key }) {
        switch (key) {
          case 'changeShowHidden':
           setShowHiddenComments(!showHiddenComments)
            break;
          case 'orderBy':
            setOrderCommentsDesc(!orderCommentsDesc)
            break;
            case 'changeUnreadOnly':
              setShowUnreadCommentsOnly(!showUnreadCommentsOnly)
              break;
          default:
            break;
        }
      }

      function filterForDisplay(comment){
        //Apply filters here
        var archivedFilter = false
        var unreadOnlyFilter = false

        //Filter for archived comments
        if (showHiddenComments) {
          archivedFilter = true
        } else {
          archivedFilter = comment.isHidden !== true
        }

        //Just stop here already if first filter fails
        if (!archivedFilter) {
          return false
        }

        //Filter for unread comments only
        if (!showUnreadCommentsOnly) {
          unreadOnlyFilter = true
        } else {
          if (userId !== comment.larperId && comment.personsWatched.filter((r) => r.larperId === userId).length === 0) {  //case 1: self unread => true
            unreadOnlyFilter = true
          } else {          //case 2: self read, 1 or more children unread => true, else false
            unreadOnlyFilter = comment.children.find((child) => userId !== child.larperId && child.personsWatched.filter((r) => r.larperId === userId).length === 0);
          }
        }        
        return unreadOnlyFilter
      }

    return (
        <>
            <div style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: 12,
            }}>
                <Divider orientation="left">Comments</Divider>
                <Dropdown overlay={actionsDropdownComments}>
                <Button icon={<MoreOutlined />} size="small" />
                </Dropdown>
            </div>

            <AntdTimeLine>
                {dataSource.sort(function(a,b){
                  
              if(orderCommentsDesc) {
                return new Date(b.lastUpdated) - new Date(a.lastUpdated);
              }
              return new Date(a.lastUpdated) - new Date(b.lastUpdated);
            }).filter(_ => filterForDisplay(_)).map(event => <TimelineItem
                key={event.id}
                event={event}
                content={content}
                actions={{
                addComment,
                saveComment,
                deleteComment,
                eventReply,
                commentRead,
                addUnreadComment,
                hideComment,
                }}
                loading={false}
            />)}
            </AntdTimeLine>
            <CommentForm
                onSubmit={addComment}
                isLoading={submitting}
                size="large"
                //content={content}
                commentBoxMode={true}
                placeholder={"Write a comment"}
            />

            {isLoading && <div style={{margin: '30px'}}>
              <Spin size="large" />
            </div>}
            <CommentReadSnackbar comments={dataSource} />
        </>
    )
}